import { useQueryErrorResetBoundary } from "@tanstack/react-query"
import * as m from "@/paraglide/messages"
import { InlineButton } from "@/shared/ui/inline-button"

interface RequestFailedProps {
	onRetry: () => void
}

function RequestFailed({ onRetry }: RequestFailedProps) {
	const { reset: resetQueryErrors } = useQueryErrorResetBoundary()

	const retry = () => {
		resetQueryErrors()
		onRetry()
	}

	return (
		<div className="flex h-full flex-col items-center justify-center gap-4 px-6">
			<p className="text-center text-base text-gray-500">
				{m.commonNetworkErrorTitle()}
			</p>
			<div className="w-full max-w-50">
				<InlineButton onClick={retry}>{m.commonBtnRetry()}</InlineButton>
			</div>
		</div>
	)
}

export type { RequestFailedProps }
export { RequestFailed }
